import { Component, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UsersService } from '../../services/users.service';
import { environment } from '../../../environments/environment';
import { AppHelper } from '../../helpers/app.helper';
import { LoggerService } from '../../services/logger.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnDestroy {
    private loadingSubject = new BehaviorSubject<boolean>(false);

    isLoading$ = this.loadingSubject.asObservable();
    error: string;

    constructor(
        private usersService: UsersService,
        private logger: LoggerService,
        private appHelper: AppHelper,
        private router: Router,
        private zone: NgZone) { }

    ngOnDestroy(): void {
        this.loadingSubject.complete();
    }

    login(): void {
        this.error = null;
        this.loadingSubject.next(true);

        Office.context.ui.displayDialogAsync(environment.loginUrl, { height: 50, width: 50 }, (result) => {
            if (result.status === Office.AsyncResultStatus.Failed) {
                this.zone.run(() => {
                    this.setError(result.error.message);
                    this.loadingSubject.next(false);
                });
            }
            else {
                const dialog = result.value;

                dialog.addEventHandler(Office.EventType.DialogMessageReceived, arg => this.onDialogMessageReceived(dialog, arg));
                dialog.addEventHandler(Office.EventType.DialogEventReceived, arg => this.onDialogEventReceived(arg));
            }
        });
    }

    private onDialogMessageReceived(loginDialog: Office.Dialog, arg: { message: string, type: string; }): void {
        let obj = JSON.parse(arg.message);

        if (!obj.code && !obj.error) {
            obj.error = `Authorization dialog is broken. There are no 'error' or 'code' values in the result.`;
        }

        if (obj.error) {
            this.setError(obj.error);
            this.loadingSubject.next(false);
        } else {
            this.usersService.login(obj.code)
                .pipe(
                    finalize(() => this.loadingSubject.next(false)))
                .subscribe(
                    value => this.router.navigate(['/taxonomies']),
                    error => this.error = this.appHelper.getErrorMessage(error));
        }

        loginDialog.close();
    }

    private onDialogEventReceived(arg: { error: number, type: string; }): void {
        switch (arg.error) {
            case 12002:
                this.setError('The dialog box has been directed to a page that it cannot find or load, or the URL syntax is invalid.');
                break;
            case 12003:
                this.setError('The dialog box has been directed to a URL with the HTTP protocol. HTTPS is required.');
                break;
            case 12006:
                this.setError('The dialog box has been closed manually. The authorization process has not been completed successfully.');
                break;
            default:
                this.setError('Unknown error in the dialog box.');
                break;
        }

        this.loadingSubject.next(false);
    }

    private setError(error: any): void {
        this.logger.error(error);
        this.error = error.toString();
    }
}
